import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MdOutlineDashboard } from "react-icons/md";
import { RiBox3Line } from "react-icons/ri";
import { BsBoxSeam } from "react-icons/bs";
import { TbReport, TbNotes } from "react-icons/tb";
import { IoAnalyticsOutline, IoTrendingDown, IoLogOutSharp } from "react-icons/io5";
import { IoIosReturnLeft } from "react-icons/io";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi2";
import JDLogo from "../../assets/JDLogo.png";
import JDSmallLogo from "../../assets/jdSmallLogo.png";
import { useAuth } from "../../context/AuthContext";

export function Sidebar({
  isSidebarOpen,
  setIsSidebarOpen,
  hoveredItem,
  setHoveredItem,
  tooltipPos,
  setTooltipPos,
  buttonRefs,
  navItems,
  location,
}) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };
  return (
    <aside
      className={`fixed md:relative top-0 left-0 h-full md:h-auto z-30 md:z-auto ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'} transition-transform duration-300 ease-in-out md:ml-5 md:mt-5 md:mb-5`}
      style={{
        backgroundColor: "#ffffff",
        border: "0.5px solid #F5EFEB66",
        borderRadius: "28px",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        marginLeft: "20px",
        marginTop: "20px",
        marginBottom: "20px",
        transition: "width 0.3s ease",
        position: "relative",
        zIndex: 30,
        overflow: "visible",
        width: isSidebarOpen ? '280px' : '80px',
      }}
    >
      {/* Logo */}
      <div
        style={{
          padding: "1.5rem",
          borderBottom: "1px solid #e5e7eb",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: isSidebarOpen ? "space-between" : "space-between",
          gap: "0.5rem",
          flexDirection: "row",
          position: "relative",
        }}
      >
        {isSidebarOpen ? (
          <img
            src={JDLogo}
            alt="JustDeliveries"
            style={{ width: "150px", height: "22px", display: "block" }}
          />
        ) : (
          <img
            src={JDSmallLogo}
            alt="JustDeliveries"
            style={{
              width: "40px",
              height: "40px",
              display: "block",
              flexShrink: 0,
            }}
          />
        )}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "0.25rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "0.25rem",
            transition: "background-color 0.2s",
            flexShrink: 0,
            marginRight: isSidebarOpen ? "0" : "-0.5rem",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f3f4f6";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
          }}
        >
          {isSidebarOpen ? (
            <HiChevronLeft style={{ fontSize: "1.25rem", color: "#4b5563" }} />
          ) : (
            <HiChevronRight style={{ fontSize: "1.25rem", color: "#4b5563" }} />
          )}
        </button>
      </div>
      {/* Navigation */}
      <nav
        style={{
          flex: 1,
          padding: "1rem",
          overflowY: "auto",
          overflowX: "visible",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
          position: "relative",
          zIndex: 1,
        }}
      >
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <div
              key={item.id}
              style={{
                position: "relative",
                zIndex: hoveredItem === item.id ? 50 : 1,
                overflow: "visible",
              }}
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <button
                ref={(el) => (buttonRefs.current[item.id] = el)}
                onClick={() => navigate(item.path)}
                style={{
                  width: "100%",
                  background: isActive ? "#FFFFFF" : "transparent",
                  color: isActive ? "#188742" : "#667085",
                  border: "none",
                  borderRadius: "14px",
                  height: "56px",
                  paddingLeft: 18,
                  paddingRight: 18,
                  paddingTop: 0,
                  paddingBottom: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: isSidebarOpen ? 12 : 0,
                  fontWeight: isActive ? 600 : 500,
                  fontSize: "0.9150rem",
                  cursor: "pointer",
                  marginBottom: "4px",
                  position: "relative",
                  transition: "background 0.2s, color 0.2s",
                  outline: "none",
                  boxShadow: isActive
                    ? "0 4px 14px rgba(16,24,40,0.06)"
                    : "none",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) e.currentTarget.style.background = "#F6F7FA";
                }}
                onMouseLeave={(e) => {
                  if (!isActive) e.currentTarget.style.background = "transparent";
                }}
              >
                {isActive && (
                  <span
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 6,
                      bottom: 6,
                      width: 4,
                      backgroundColor: "#188742",
                      borderRadius: "0 6px 6px 0",
                    }}
                    aria-hidden
                  />
                )}
                <item.icon
                  style={{
                    fontSize: "1.125rem",
                    flexShrink: 0,
                    color: isActive ? "#188742" : "#667085",
                    marginRight: isSidebarOpen ? 12 : 0,
                  }}
                />
                {isSidebarOpen && (
                  <span style={{ flex: 1, textAlign: "left" }}>
                    {item.label}
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </nav>
      {/* Logout at bottom */}
      <div
        style={{
          padding: "1rem",
          borderTop: "1px solid #e5e7eb",
          flexShrink: 0,
        }}
      >
        <button
          type="button"
          onClick={handleLogout}
          style={{
            width: "100%",
            background: "#16A34A0D",
            border: "0.5px solid #16A34A",
            borderRadius: "12px",
            padding: isSidebarOpen ? "10px 14px" : "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: isSidebarOpen ? "space-between" : "center",
            gap: isSidebarOpen ? "12px" : "0",
            color: "#16A34A",
            fontWeight: 500,
            fontSize: "0.8125rem",
            cursor: "pointer",
            transition: "background 0.2s, opacity 0.2s",
            outline: "none",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = "#16A34A1A";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = "#16A34A0D";
          }}
        >
          {isSidebarOpen && <span>Logout</span>}
          <IoLogOutSharp style={{ fontSize: "1.125rem", flexShrink: 0 }} />
        </button>
      </div>
    </aside>
  );
}
